import { makeStyles, withStyles, Theme } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#bbdefb",
    color: "#1a237e",
    fontSize: "14px",
    fontWeight: 600,
  },
  body: {
    fontSize: "14px",
    fontWeight: 600,
    maxWidth: "200px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
}))(TableCell);

export const useStyles = makeStyles((theme: Theme) => ({
  bulkCreateButton: {
    "& span": {
      fontWeight: 600,
      marginLeft: "10px",
    },
    "& svg": {
      fill: "#fff",
    },
  },
  wrapText: {
    "& .MuiListItemText-primary": {
      whiteSpace: "normal !important",
      wordBreak: "break-word !important",
    },
  },
  rightAlignCell: {
    "& .MuiGrid-container": {
      alignItems: "flex-end !important",
    },
  },
}));
